module.exports = __webpack_public_path__ + "static/media/cptm_cover.aa7bd478.jpg";